import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';

import { MINIMUM_PAGES_FOR_PAGINATION } from '../../constants/pagination';

const Pagination = (props) => {
  const {
    meta: { totalPages, currentPage },
    onPageChange,
  } = props;

  if (totalPages < MINIMUM_PAGES_FOR_PAGINATION) return <div></div>;

  return (
    <ReactPaginate
      pageCount={totalPages}
      onPageChange={onPageChange}
      forcePage={currentPage - 1}
      containerClassName="pagination"
      pageClassName="pagination-item"
      pageLinkClassName="pagination-item-link"
      breakClassName="pagination-item-link"
      activeLinkClassName="-active"
      disabledClassName="pagination-item -disabled"
      nextClassName="pagination-item"
      nextLinkClassName="pagination-item-link -next"
      previousClassName="pagination-item"
      previousLinkClassName="pagination-item-link -prev"
      previousLabel="previous"
      nextLabel="next"
    />
  );
};

export default Pagination;

Pagination.propTypes = {
  meta: PropTypes.shape({
    totalPages: PropTypes.number,
    currentPage: PropTypes.number,
  }).isRequired,
  onPageChange: PropTypes.func.isRequired,
};
